import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type Particle = {
  left: string;
  top: string;
  size: number;
  delay: number;
};
const particles: Particle[] = [{
  left: "3%",
  top: "8%",
  size: 2,
  delay: 0.1
}, {
  left: "7%",
  top: "32%",
  size: 1,
  delay: 1.3
}, {
  left: "10%",
  top: "61%",
  size: 2,
  delay: 2.2
}, {
  left: "13%",
  top: "18%",
  size: 1,
  delay: 0.8
}, {
  left: "16%",
  top: "79%",
  size: 2,
  delay: 3.1
}, {
  left: "19%",
  top: "45%",
  size: 1,
  delay: 1.8
}, {
  left: "22%",
  top: "12%",
  size: 2,
  delay: 2.7
}, {
  left: "25%",
  top: "68%",
  size: 1,
  delay: 0.4
}, {
  left: "28%",
  top: "35%",
  size: 2,
  delay: 1.1
}, {
  left: "31%",
  top: "88%",
  size: 1,
  delay: 3.5
}, {
  left: "34%",
  top: "22%",
  size: 2,
  delay: 2.0
}, {
  left: "37%",
  top: "53%",
  size: 1,
  delay: 0.6
}, {
  left: "40%",
  top: "7%",
  size: 2,
  delay: 1.6
}, {
  left: "43%",
  top: "73%",
  size: 1,
  delay: 2.9
}, {
  left: "46%",
  top: "38%",
  size: 2,
  delay: 0.2
}, {
  left: "49%",
  top: "91%",
  size: 1,
  delay: 1.4
}, {
  left: "52%",
  top: "15%",
  size: 2,
  delay: 3.0
}, {
  left: "55%",
  top: "58%",
  size: 1,
  delay: 0.9
}, {
  left: "58%",
  top: "28%",
  size: 2,
  delay: 1.9
}, {
  left: "61%",
  top: "81%",
  size: 1,
  delay: 2.5
}, {
  left: "64%",
  top: "43%",
  size: 2,
  delay: 0.5
}, {
  left: "67%",
  top: "6%",
  size: 1,
  delay: 3.3
}, {
  left: "70%",
  top: "66%",
  size: 2,
  delay: 1.2
}, {
  left: "73%",
  top: "21%",
  size: 1,
  delay: 2.6
}, {
  left: "76%",
  top: "84%",
  size: 2,
  delay: 0.7
}, {
  left: "79%",
  top: "49%",
  size: 1,
  delay: 3.4
}, {
  left: "82%",
  top: "11%",
  size: 2,
  delay: 1.7
}, {
  left: "85%",
  top: "72%",
  size: 1,
  delay: 2.3
}, {
  left: "88%",
  top: "34%",
  size: 2,
  delay: 0.3
}, {
  left: "91%",
  top: "93%",
  size: 1,
  delay: 3.2
}, {
  left: "94%",
  top: "57%",
  size: 2,
  delay: 1.0
}, {
  left: "97%",
  top: "19%",
  size: 1,
  delay: 2.8
}];
export function PoolShimmer() {
  const prefersReducedMotion = useReducedMotion();
  return <div className="pointer-events-none absolute bottom-[2%] left-[3%] right-[3%] z-[1] h-[34%] overflow-hidden" aria-hidden="true" data-id="element-50" data-mp="3fci8qcizni56">
      {particles.map(particle => <motion.span key={`${particle.left}-${particle.top}`} className="pool-shimmer-particle absolute rounded-full bg-white" style={{
      left: particle.left,
      top: particle.top,
      width: particle.size,
      height: particle.size
    }} animate={prefersReducedMotion ? {
      opacity: 0.42
    } : {
      opacity: [0.08, 0.8, 0.14]
    }} transition={prefersReducedMotion ? undefined : {
      duration: 2.8,
      delay: particle.delay,
      repeat: Infinity,
      repeatType: "mirror",
      ease: "easeInOut"
    }} data-id="element-51" data-mp="1iekkmbef5pex" />)}
    </div>;
}